import { CRIAR_PAGINA_SITE, DELETAR_PAGINA_SITE, EDITAR_PAGINA_SITE, CARREGAR_PAGINAS_SERVER, CARREGAR_PAGINAS_NA_STORE } from "../constants/constants";

export const adicionarNovaPaginaSite = (nome, conteudo = '') => ({
    type : CRIAR_PAGINA_SITE, nome, conteudo, id : Date.now()
})

export const removerPaginaSite = (id) => ({
    type : DELETAR_PAGINA_SITE, id
})

export const editarPaginaSite = (id, nome, conteudo ='') => ({
    type : EDITAR_PAGINA_SITE, id, conteudo, nome
}) 

export const carregarPaginas = () =>({
    type : CARREGAR_PAGINAS_SERVER
})

export const carregarPaginasStore = (paginas) => ({
    type : CARREGAR_PAGINAS_NA_STORE, paginas
})

window.adicionarNovaPaginaSite = adicionarNovaPaginaSite;
window.removerPaginaSite = removerPaginaSite
window.editarPaginaSite = editarPaginaSite


// WEBPACK FOOTER //
// ./src/actions/paginas.js